onComplete(function () {

	const isHome = document.querySelector('html[data-home="true"]')

	if (isHome) {

		const headerOverlay = document.querySelector('.header .absolute-header-overlay');
		headerOverlay.style.opacity = "1";

		const headerOverlayTxt = document.querySelector('.content-subtemplate-home .header p.header-element-title')
		headerOverlayTxt.style.transform = "scale(0.9)";
		headerOverlayTxt.style.opacity = "0.8";
	}

	window.addEventListener('scroll', function () {
		const navHeader = document.querySelector('.nav-header');
		const currentScrollPos = window.scrollY || document.documentElement.scrollTop;

		if (currentScrollPos > 75) {
			navHeader.style.backgroundColor = "var(--tertiary)";
		} else {
			navHeader.style.backgroundColor = "transparent";
		}

	});

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.setAttribute('data-in-view', '');
			}
		});
	});

	const elementsAnimate = document.querySelectorAll('.animal-elements, .form-box');
	elementsAnimate.forEach(element => observer.observe(element));
});
